import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Battery1BarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"battery_1_bar"}/>
}
